import React from 'react'
import { useSelector } from 'react-redux'
import { isSubmitting } from 'redux-form'
//@ts-ignore
import { SubmitButton } from 'shared/LKButton'
import { translate } from '../../helpers'
import { INSTANCE_NAME } from '../../constants'

const isFormSubmitting = isSubmitting(INSTANCE_NAME)

const AccSearchSubmitButton = () => {
  const submitting = useSelector((state) => isFormSubmitting(state))

  return (
    <SubmitButton loading={submitting} disabled={submitting}>
      {translate('cmd_find')}
    </SubmitButton>
  )
}

export default AccSearchSubmitButton
